<template>
  <div>
    <div class="handle">
      {{ user.name}}</el-span><el-button @click="event">退出</el-button>
    </div>
    <div class="about">
      <div class="pancel">
        <div v-for="item in data" class="item" :key="item.title">
          <el-button @click="startFile(item.path, item.title)">{{
            item.title
          }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
    <script>
import { MessageBox } from "element-ui";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      data: [],
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    this.getFile();
  },
  beforeMount() {
    this.getFile();
  },
  methods: {
    event() {
      MessageBox.confirm("登录", "确认退出?", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((e) => {
          this.logout();
        })
        .catch(() => {
          //
        });
    },
    logout() {
        this.$store
          .dispatch("logout")
          .then(() => {
            localStorage.clear();
            this.$router.replace("/login");
          })
          .catch(() => {});

      // this.$confirm("确认退出么？", { type: "warning" }).then(() => {
      //   this.$store
      //     .dispatch("logout")
      //     .then(() => {
      //       localStorage.clear();
      //       this.$router.replace("/login");
      //     })
      //     .catch(() => {});
      // });
    },
    startFile(path, title) {
      this.$router.push({ path: "/file", query: { path: path, title: title } });
      localStorage.setItem("current", title);
    },
    getFile() {
      this.$api.index().then((res) => {
        this.data = res.data;
        console.log(this.data)
        localStorage.setItem("list", JSON.stringify(res.data));
      });
    },
  },
};
</script>
<style>
.handle {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.about {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;
}
.pancel {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 80%;
  align-items: center;
}
.item {
  width: 23%;
  text-align: center;
  margin-bottom: 22px;
  box-sizing: border-box;
}
.item .el-button {
  width: 100%;
  font-size: 32px;
  padding: 25px;
}
</style>
